import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Modal, Skeleton } from 'antd';
import { useEffect, useState } from 'react';

import { Drawer } from '../../../../components/index';
import { useLazyGetStopoverOptimizedQuery } from '../../../../services/stopoverApi';
import { Stopover as StopoverType } from '../../../../types';
import { formatStopoverToForm } from '../../../../utils/formatters';
import { StopoverDetails } from '../../stopover/stopoverDetails/StopoverDetails';

const { confirm } = Modal;

type StopoverPendencyDrawerProps = {
  stopoverId: number | null;
  onClose: () => void;
};

// Detalhe da escala (o mesmo da tela de Escalas) para completar, a partir do
// relatório, os dados que faltam. As alterações invalidam o cache do relatório.
export function StopoverPendencyDrawer({
  stopoverId,
  onClose,
}: StopoverPendencyDrawerProps) {
  const [selectedStopover, setSelectedStopover] = useState<StopoverType>(
    {} as StopoverType
  );
  const [hasEdited, setHasEdited] = useState(false);
  const [blockNavigate, setBlockNavigate] = useState(false);
  const [getStopover, { data, isFetching }] =
    useLazyGetStopoverOptimizedQuery();

  useEffect(() => {
    if (stopoverId) getStopover({ id: stopoverId });
  }, [stopoverId, getStopover]);

  useEffect(() => {
    if (data && data.id === stopoverId) {
      setSelectedStopover(formatStopoverToForm(data));
    }
  }, [data, stopoverId]);

  function close() {
    setHasEdited(false);
    setBlockNavigate(false);
    setSelectedStopover({} as StopoverType);
    onClose();
  }

  function handleClose() {
    if (!hasEdited) {
      close();
      return;
    }
    confirm({
      title: 'Tem certeza que deseja sair?',
      icon: <ExclamationCircleOutlined />,
      content:
        'Você tem alterações não salvas na escala, ao sair perderá os dados preenchidos.',
      okText: 'Sim',
      okType: 'danger',
      cancelText: 'Não',
      onOk: close,
    });
  }

  const isLoaded = selectedStopover.id === stopoverId && !isFetching;

  return (
    <Drawer
      visible={!!stopoverId}
      onClose={handleClose}
      width={1100}
      closable={false}
      maskClosable
      destroyOnClose
    >
      {isLoaded ? (
        <StopoverDetails
          name="stopover_pendency_form"
          selectedStopover={selectedStopover}
          setSelectedStopover={setSelectedStopover}
          hasEdited={hasEdited}
          setHasEdited={setHasEdited}
          blockNavigate={blockNavigate}
          setBlockNavigate={setBlockNavigate}
          onCloseDrawer={handleClose}
          showBackButton
        />
      ) : (
        <Skeleton active style={{ padding: '24px' }} />
      )}
    </Drawer>
  );
}
